<template>
  <div v-if="performanceAddOn" class="flex flex-col items-start gap-6">
    <router-link
      id="back-to-list-link"
      class="text-fg-link-primary flex items-center gap-2 text-sm"
      :to="{ name: PERFORMANCE_ROUTE_NAMES.ADD_ONS }"
      replace
    >
      <ResArrowLeftIcon />
      <span>Back to Add-on List</span>
    </router-link>

    <SlotPanel classes="w-full">
      <PerformanceAddOnForm
        :key="performanceAddOn.id"
        :initialAddOn="initialAddOn"
        v-model="performanceAddOn"
      />
    </SlotPanel>
  </div>
</template>

<script setup lang="ts">
import * as _ from 'lodash-es'
import { storeToRefs } from 'pinia'
import { computed, toRefs } from 'vue'

import ResArrowLeftIcon from '@/assets/resArrowLeft.svg?component'
import SlotPanel from '@/common/components/organisms/SlotPanel.vue'
import PerformanceAddOnForm from '@/modules/performance/components/organisms/PerformanceAddOnForm.vue'
import { PERFORMANCE_ROUTE_NAMES } from '@/modules/performance/constants/PerformanceRouteConstants'
import { usePerformanceReservationStore } from '@/modules/performance/stores/PerformanceReservationStore'
import { usePerformanceUpdateStore } from '@/modules/performance/stores/PerformanceUpdateStore'

import { PerformanceAddOnId, PerformanceAddOnRead } from '@generated/types'

const props = defineProps<{ addOnId: PerformanceAddOnId }>()
const { addOnId } = toRefs(props)

const { selectedPerformance } = storeToRefs(usePerformanceReservationStore())
const initialAddOn = computed<PerformanceAddOnRead | undefined>(() => {
  return _.find(selectedPerformance.value?.add_ons, { id: addOnId.value })
})

const performanceUpdateStore = usePerformanceUpdateStore()
const { updatedPerformance } = storeToRefs(performanceUpdateStore)
const performanceAddOn = computed<PerformanceAddOnRead | undefined>({
  get: () => _.find(updatedPerformance.value!.add_ons, { id: addOnId.value }),
  set: performanceUpdateStore.updateAddOn,
})
</script>
